module.exports = __webpack_public_path__ + "img/book_active.7b1d2a91.png";